import { magicNumbers } from 'utils';

export const telegramInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    filterType: 'include',
    platform: 'telegram',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    isDisabled: true,
    hasActivateSwitch: true,
    hasIncludeExclude: true,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: true,
    platform: 'telegram',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'telegram',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  mediaTypeFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    platform: 'telegram',
    componentName: 'mediaTypeFilter',
    translateKey: 'filter:mediaType',
    isDisabled: true,
    hasActivateSwitch: true,
  },
  languageFilter: {
    title: 'filter:baseOnLanguage',
    isDisabled: true,
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
    hasActivateSwitch: true,
  },
  contentBasedFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjects: {
      view: {
        type: 'text',
        active: false,
        max: null,
        min: null,
        label: 'filter:viewCount',
        method: 'max',
        defaultMax: magicNumbers.CONTENT_BASED_FILTER_DEFAULT_MAX_VALUE,
        toggler: 'switch',
      },
      influenceRate: {
        type: 'checkboxes',
        active: false,
        selectedIds: [],
        label: 'filter:resourceInfluenceRate',
        toggler: 'switch',
      },
    },
    componentName: 'contentBasedFilter',
    translateKey: 'filter:resourceBasedOn',
  },
  contentCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    componentName: 'contentCategoryFilter',
    translateKey: 'filter:contentCategory',
    selectedCategories: {},
    isDisabled: true,
    hasActivateSwitch: true,
    openSubCategories: true,
  },
};
